import styled, { css } from "styled-components";
import { Input as SharedInput } from "../Modals/DocumentModal/DocumentModal.styles";
import { pxToRem, withAlpha } from "../../styles/utils";

export const CalendarInputRoot = styled.div`
  position: relative;
  width: 100%;
`;

export const CalendarFieldInput = styled(SharedInput)<{ $hasError?: boolean }>`
  ${({ $hasError, theme }) =>
    $hasError &&
    css`
      border-color: ${theme.colors.danger};
      background: ${withAlpha(theme.colors.brand, 0.15)};
      --autofill-background: ${withAlpha(theme.colors.brand, 0.15)};
    `}
`;

export const CalendarPopup = styled.div<{
  $top: number;
  $left: number;
  $ready: boolean;
}>`
  position: fixed;
  /*
    top/left приходят из getBoundingClientRect и уже заданы в физических
    координатах viewport. Здесь намеренно не используется pxToRem.
  */
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $left }) => `${$left}px`};
  z-index: 1100;
  width: max-content;
  max-width: calc(100vw - ${pxToRem(32)});
  visibility: ${({ $ready }) => ($ready ? "visible" : "hidden")};
`;